<template>
  <div class="main">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">申请</div>
      <div class="nav-right">
        <img class="none" />
      </div>
    </div>
    <div class="info2">
        <span class="sp1">上传录音</span>
        <div class="ub ub-ver ub-pc">
           <img src="../../assets/img/添加录音.png" class="add-img" />
           <span class="sp2">上传录音</span>
        </div>
    </div>
    <div class="ub ub-ac" style="padding: 0 .8em;">
      <div class="ub ub-ac ub-pc submit-btn" @click="save()" >下一步</div>
    </div>
   
  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      "vol":"http://curmsg.zhuochuangzb.com/Scripts/sound.mp3"
    };
  },
  mounted() {
   this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
    back() {
      this.$router.go(-1); //返回上一层
    },

    init_page() {
      var uid = this.$store.state.uid;
      var self = this;
      this.$loading("加载...");
      setTimeout(() => {
        self.$loading.close();
      }, 5000);
      self.get({
        url: "/App/Get_Play_Data_One/?uid=" + uid,
        success: function (data) {
          self.$loading.close();
          console.log(JSON.stringify(data));
          if( data.vol){
            self.vol = data.vol;
          }
          
        },
      });
    },

    save(){
      if(this.vol==""){
        this.$toast.center("请上传录音");
        return false;
      }

      var uid = this.$store.state.uid;

     var self = this;
     var data_send={
       "vol":this.vol
     };
     var strsend = JSON.stringify(data_send);

      this.post({
          url: "/App/Update_User_Play",
          data: { "uid": uid, "data": strsend },
          success: function (serve_data) {
           console.log(JSON.stringify(serve_data));
            if(serve_data.state=="1"){
              self.$router.push({ "name": "play_apply3"});
            }
          },
        });
     
    }
  },
};
</script>

<style scoped>
.main{
   position: absolute;
   background-color: #fff;
   width: 100%;
   bottom: 0;
   top:0;
 }

.info2{
  padding: .8em;
  border-bottom: .5em solid #f5f5f5;
}
.info2 .sp1{
  font-size: 1.05em;
  font-weight: bold;
}
.info2 .sp2{
  font-size: 1.2em;
}
.add-img{
    width: 3em;
    height: 3em;
    margin-bottom: .5em;
}
  .submit-btn {
  width: 100%;
  height: 2.3em;
  line-height: 2.3em;
  border-radius: 1.15em;
  background-color: #fc568c;
  margin-top: .5em;
  color: #fff0f4;
}
</style>